import { useMemo } from 'react';

const bandColor = (score) => {
  if (score >= 75) return { hex: '#EF4444', name: 'critical' };
  if (score >= 50) return { hex: '#F59E0B', name: 'elevated' };
  if (score >= 25) return { hex: '#EAB308', name: 'moderate' };
  return { hex: '#10B981', name: 'safe' };
};

export function RiskGauge({ score = 0, label = 'Safe', size = 220, testId }) {
  const s = Math.max(0, Math.min(100, Math.round(score)));
  const { hex } = bandColor(s);
  const radius = size / 2 - 14;
  const circumference = Math.PI * radius; // half-circle
  const dash = (s / 100) * circumference;
  const cx = size / 2;
  const cy = size / 2 + 20;

  const ticks = useMemo(
    () => Array.from({ length: 11 }, (_, i) => (i * Math.PI) / 10),
    []
  );

  return (
    <div className="flex flex-col items-start" data-testid={testId}>
      <svg width={size} height={size / 2 + 40} viewBox={`0 0 ${size} ${size / 2 + 40}`}>
        {/* track */}
        <path
          d={`M ${cx - radius} ${cy} A ${radius} ${radius} 0 0 1 ${cx + radius} ${cy}`}
          fill="none"
          stroke="#27272A"
          strokeWidth="12"
        />
        {/* fill */}
        <path
          d={`M ${cx - radius} ${cy} A ${radius} ${radius} 0 0 1 ${cx + radius} ${cy}`}
          fill="none"
          stroke={hex}
          strokeWidth="12"
          strokeDasharray={`${dash} ${circumference}`}
          style={{ transition: 'stroke-dasharray .6s cubic-bezier(.2,.8,.2,1), stroke .3s' }}
        />
        {/* ticks */}
        {ticks.map((a, i) => {
          const x1 = cx + Math.cos(Math.PI - a) * (radius - 18);
          const y1 = cy - Math.sin(Math.PI - a) * (radius - 18);
          const x2 = cx + Math.cos(Math.PI - a) * (radius - 8);
          const y2 = cy - Math.sin(Math.PI - a) * (radius - 8);
          return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#3f3f46" strokeWidth={i % 5 === 0 ? 2 : 1} />;
        })}
      </svg>
      <div className="-mt-16 flex flex-col leading-none">
        <span className="font-sans text-5xl font-black tracking-tighter" style={{ color: hex }}>
          {s}
        </span>
        <span className="mt-1 text-[10px] uppercase tracking-[0.28em] text-zinc-500">risk · {label}</span>
      </div>
    </div>
  );
}

export default RiskGauge;
